import css from "../assets/fileTypes/css.svg";
import docker from "../assets/fileTypes/docker.svg";
import html from "../assets/fileTypes/html.svg";
import javascript from "../assets/fileTypes/javascript.svg";
import json from "../assets/fileTypes/json.svg";
import markdown from "../assets/fileTypes/markdown.svg";
import python from "../assets/fileTypes/python.svg";
import react from "../assets/fileTypes/react.svg";
import shell from "../assets/fileTypes/shell.svg";
import toml from "../assets/fileTypes/toml.svg";
import typescript from "../assets/fileTypes/typescript.svg";
import yaml from "../assets/fileTypes/yaml.svg";
import { ConnectorImage } from "./ConnectorImage";
import { Icon, type Size } from "./Icon";

const logoByExtension: Record<string, string> = {
  bash: shell,
  cjs: javascript,
  css,
  cts: typescript,
  htm: html,
  html,
  js: javascript,
  json,
  jsx: react,
  md: markdown,
  mjs: javascript,
  mts: typescript,
  py: python,
  sh: shell,
  toml,
  ts: typescript,
  tsx: react,
  yaml,
  yml: yaml,
};

const imageExtensions = new Set([
  "avif",
  "gif",
  "ico",
  "jpeg",
  "jpg",
  "png",
  "svg",
  "webp",
]);

function extension(name: string) {
  const dot = name.lastIndexOf(".");
  return dot > 0 ? name.slice(dot + 1).toLowerCase() : "";
}

export function FileTypeIcon({ path, size }: { path: string; size: Size }) {
  const name = path.slice(path.lastIndexOf("/") + 1);
  const ext = extension(name);
  const logo =
    name === "Dockerfile" || ext === "dockerfile"
      ? docker
      : logoByExtension[ext];
  if (logo) {
    return (
      <ConnectorImage
        alt=""
        src={logo}
        width={size}
        height={size}
        style={{ flexShrink: 0 }}
      />
    );
  }
  return (
    <Icon
      name={
        name === ".cron" ? "clock" : imageExtensions.has(ext) ? "image" : "file"
      }
      size={size}
    />
  );
}
